import { GRID_SIZE } from '../config/constants'
import { StaticEntity } from './static-entity'

export const Ladder = ({ x, y, width = GRID_SIZE, height = GRID_SIZE, config = {} }) =>
  <StaticEntity x={x} y={y} width={width} height={height} entityType="ladder" config={config} />
